var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73443 4.46287L0.110135 0.847768C-0.0367116 0.703532 -0.0367116 0.4703 0.110135 0.326065L0.331966 0.108177C0.478813 -0.0360589 0.716266 -0.0360589 0.863113 0.108177L4 3.2476L7.13689 0.111246C7.28373 -0.0329901 7.52119 -0.0329901 7.66803 0.111246L7.88987 0.329133C8.03671 0.473369 8.03671 0.706601 7.88987 0.850837L4.26557 4.46593C4.11873 4.6071 3.88127 4.6071 3.73443 4.46287Z",
    fill: "#656668"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e26324e9750b7f1d6679b1e4d65bd16e.svg";
export { ForwardRef as ReactComponent };